import axios from "axios";

export function deleteQrcode(qrcodeId, type) {
  var config = {
    method: "delete",
    url: `${process.env.VUE_APP_APIHOST}/${type}/qrcode/${qrcodeId}`,
    data: {
    }
  };
  return axios(config);
}


export function deleteOrderLimit(data) {
  var config = {
    method: "delete",
    url: `${process.env.VUE_APP_APIHOST}/${data.type}/accounts/${data.accountId}/order-limits/${data.id}`,
  };
  return axios(config);
}

export function delStore(accountId, si="quickclick") {
  var config = {
    method: "DELETE",
    url: `${process.env.VUE_APP_APIHOST}/apis/line-spot/si/${si}/accounts/${accountId}`
  };
  return axios(config);
}

export function delLineModule(accountId) {
  var config = {
    method: "DELETE",
    url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${accountId}/line-module`
  };
  return axios(config);
}

export function deletePromotion(data, type) {
  var config = {
    method: "delete",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${data.businessId}/promotions/${data.id}`,
  };
  return axios(config);
}


export function removePosmw(accountId, id, type) {
  let config = {
    method: 'DELETE',
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${accountId}/mw-settings/${id}`,
    data: {id}
  };
  return axios(config);
}


export function deleteScanner(accountId, type, scannerSn) {
  let config = {
    method: 'DELETE',
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${accountId}/scanners/${scannerSn}`,
  }
  return axios(config);
}